module.exports = __webpack_public_path__ + "d00efd5a5c5dc1d03f3510a0c551f515.MP3";